import React, { Component, ReactNode } from 'react'
import classNames from 'classnames'
import { CircularProgress } from '@chakra-ui/react'

import IconTick from '../icon/IconTick'
import IconX from '../icon/IconX'

import './CircleProgress.less'

interface IProps {
  progress: number // 0 - 1.0
  failed?: boolean
  completed?: boolean
  lineWidth: number
  lineColor: string
  backgroundLineColor?: string
  backgroundColor?: string
  children?: any
}

// TODO refactor to FC
export default class CircleProgress extends Component<IProps> {
  render(): ReactNode {
    const { children, progress, failed, completed } = this.props

    const progressClasses = classNames('CircleProgress', {
      CircleProgress__notstarted: progress === 0
    })

    return (
      <div className={progressClasses}>
        {failed ? (
          <IconX size="large" />
        ) : completed ? (
          <IconTick />
        ) : (
          <>
            <CircularProgress
              display="flex"
              size="64px"
              thickness="12"
              value={progress * 100}
              trackColor="rgba(210,210,210,.5)"
            />
            <div className="CircleProgress__content">{children}</div>
          </>
        )}
      </div>
    )
  }
}
